/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_View_Complete_BenefitInputs */

const en_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Full Plan Details`)
};

const ar_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض تفاصيل الخطة الكاملة`)
};

const de_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Plandetails anzeigen`)
};

const es_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los detalles del plan`)
};

const fr_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir les détails du plan complet`)
};

const it_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizza i dettagli completi del piano`)
};

const ja_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランの詳細を見る`)
};

const ko_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 플랜 세부 정보 보기`)
};

const pt_br_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver dados completos do plano`)
};

const ru_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотреть полную информацию о плане`)
};

const th_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูรายละเอียดแผนแบบเต็ม`)
};

const tr_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Plan Detaylarını Görüntüle`)
};

const zh_cn_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整方案内容`)
};

const zh_tw_subscription_view_complete_benefit = /** @type {(inputs: Subscription_View_Complete_BenefitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整方案內容`)
};

/**
* | output |
* | --- |
* | "View Full Plan Details" |
*
* @param {Subscription_View_Complete_BenefitInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_view_complete_benefit = /** @type {((inputs?: Subscription_View_Complete_BenefitInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_View_Complete_BenefitInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_view_complete_benefit(inputs)
	if (locale === "ar") return ar_subscription_view_complete_benefit(inputs)
	if (locale === "de") return de_subscription_view_complete_benefit(inputs)
	if (locale === "es") return es_subscription_view_complete_benefit(inputs)
	if (locale === "fr") return fr_subscription_view_complete_benefit(inputs)
	if (locale === "it") return it_subscription_view_complete_benefit(inputs)
	if (locale === "ja") return ja_subscription_view_complete_benefit(inputs)
	if (locale === "ko") return ko_subscription_view_complete_benefit(inputs)
	if (locale === "pt_br") return pt_br_subscription_view_complete_benefit(inputs)
	if (locale === "ru") return ru_subscription_view_complete_benefit(inputs)
	if (locale === "th") return th_subscription_view_complete_benefit(inputs)
	if (locale === "tr") return tr_subscription_view_complete_benefit(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_view_complete_benefit(inputs)
	return zh_tw_subscription_view_complete_benefit(inputs)
});